module.exports = __webpack_public_path__ + "img/adopt.c42ca8c0.png";